<template>
  <div class="coach-page">
    <div class="section-background auto-height pb-0">
      <div class="container">
        <div class="hero">
          <div class="text">
            <div
              v-if="loading"
              class="loading-spinner"
            >
              <div
                class="spinner-border"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div
              v-else
              class="flex"
            >
              <div class="profile-header">
                <div class="image">
                  <img
                    :src="coach.profile_pic"
                    :alt="fullname"
                  >
                </div>
                <div class="information">
                  <div class="name">
                    {{ fullname }}
                  </div>
                  <div class="keywords">
                    <span>
                      {{ coach.tag }}
                      <br>
                      {{ location }}
                    </span>
                    <br>
                    {{ coach.experience }} years of experience
                  </div>
                </div>
                <div class="cta">
                  <!-- <div class="muted">
                    <del>
                      <b>$ {{ coachFees * 2 }}</b></del>
                  </div> -->
                  <div class="price">
                    <span><b>$</b> {{ coachFees }}</span>
                    <span>/Session*</span>
                  </div>
                  <div class="buttons">
                    <b-button
                      variant="primary"
                      class="primary-button primary with-icon"
                      @click="hireCoach(1)"
                    >
                      Hire {{ firstname }}
                    </b-button>
                  </div>
                  <div class="session-description">
                    * a session includes analysis of <b>2 videos</b> of
                    <b>max. 3 minutes</b> each.
                  </div>
                </div>
              </div>
              <div class="profile-body">
                <div class="general-information">
                  <table>
                    <tr v-if="coach.specialism">
                      <td><h4>Specialism</h4></td>
                      <td>
                        <ul class="specs-list">
                          <li
                            v-for="(specialism, i) in coach.specialism
                              .specialism"
                            :key="i"
                            :value="specialism"
                          >
                            {{ specialism }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr v-if="coach.certifications">
                      <td><h4>Certifications</h4></td>
                      <td>
                        <ul class="specs-list">
                          <li
                            v-for="(level, i) in coach.certifications
                              .certifications"
                            :key="i"
                            :value="level"
                          >
                            {{ level }}
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="bio">
                  <h4>About {{ firstname }}</h4>
                  <!-- eslint-disable-next-line -->
                  <div v-html="coach.description" />
                </div>
                <div
                  v-if="
                    coach.images &&
                      coach.images.images &&
                      coach.images.images.length
                  "
                  class="media-lib"
                >
                  <h4>{{ firstname }} in action</h4>

                  <div class="masonry">
                    <div
                      v-for="(chunk, i) in getImageChunks"
                      :key="i"
                      class="item"
                      :value="i"
                    >
                      <img
                        v-for="(image, j) in chunk"
                        :key="j"
                        :value="j"
                        :src="image"
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CoachService from "@/services/coaches";
import _ from "lodash";
export default {
  name: "CoachProfile",
  data() {
    return {
      loading: true,
      coach: { user: {} },
    };
  },
  computed: {
    coachFees() {
      const fees = this.coach.fees ? this.coach.fees / 4 : 0;
      return fees ? `${fees.toFixed(2)}` : `Not Available`;
    },
    firstname() {
      return this.coach.user.firstname;
    },
    fullname() {
      return `${this.coach.user.firstname} ${this.coach.user.lastname}`;
    },
    location() {
      if (this.coach.city && this.coach.country) {
        return `${this.coach.city}, ${this.coach.country}`;
      }
      return "-";
    },
    getImageChunks() {
      return _.chunk(this.coach.images.images, 1);
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await CoachService.getExclusiveCoach(this.$route.params.slug, {
        _related: "user",
      });
      if (!response.data || response.data.status !== "APPROVED") {
        this.$router.push({ name: "error" });
        return;
      }
      this.coach = response.data ? response.data : this.coach;
      this.$ma.trackEvent({
        fb_event: "ViewContent",
        category: "Coach_Profile_Private",
        action: "View",
        label: `${this.fullname}`,
        type: "View",
      });
      this.loading = false;
    },
    hireCoach(numSessions) {
      this.$router.push({
        name: "hire-coach-form",
        params: { id: this.coach.id },
        query: Object.assign({exclusive: true, num_sessions: numSessions }, this.$route.query) 
      });
    },
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Coach ${this.fullname}`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style lang="scss" scoped>
.item {
  display: inline-block;
  margin: 0 10px 0 0;
  overflow: hidden;
  img {
    max-width: 100%;
    height: 200px;
  }
}

.profile-body {
  border-radius: 4px;
  padding: 20px;
  background: #f9f9f9;
}

.profile-header {
  min-width: 300px;
  margin-right: 40px;
  position: sticky;
  top: 80px;
  max-height: 700px;

  .image {
    min-width: 250px;
    max-width: 300px;
    margin-bottom: 20px;
    img {
      max-width: 100%;
      border-radius: 4px;
      box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.25);
    }
  }

  .information {
    .name {
      font-size: 25px;
      font-weight: 600;
    }

    .keywords {
      font-size: 14px;
    }

    .languages {
      margin: 15px 0 0;
      font-size: 12px;

      span {
        display: inline-block;
      }

      img {
        position: relative;
        top: -1px;
      }

      b {
        margin: 0 10px 0 5px;
        opacity: 0.5;
        font-weight: normal;
      }
    }
    .rating {
      color: #6e44ff;
      i {
        font-size: 20px;
      }
    }
  }

  .cta {
    .buttons {
      .primary-button {
        text-align: center;
        width: 100%;
      }
    }
    .session-description {
      opacity: 0.5;
      font-size: 12px;
      margin: 10px 0;
    }
  }
}

.price {
  color: #00c088;
  font-size: 40px;
  font-weight: 600;
  margin: 20px 0 15px;

  b {
    font-size: 30px;
    font-weight: 600;
  }

  span {
    display: inline-block;
    line-height: 1;

    &:nth-child(2) {
      font-size: 14px;
      font-weight: normal;
      margin-top: 10px;
    }
  }
}

ul.specs-list {
  li {
    margin: 0px 10px 10px 0;
    float: left;
    width: auto;
    &:after {
      content: "|";
      padding-left: 10px;
      opacity: 0.3;
    }
    &:last-child {
      &:after {
        content: none;
      }
    }
  }
}

h4 {
  margin: 20px 0 10px;
  border-top: 1px solid #eee;
  padding-top: 20px;
}

.general-information {
  table {
    display: block;
    tr {
      display: inline-block;
      vertical-align: top;
      width: 100%;
      margin: 0 0 10px;
      td {
        display: block;
        font-weight: normal;
        &:first-child {
          font-weight: 600;
        }
      }
      &:nth-child(1) {
        h4 {
          border-top: none;
          padding-top: 0;
          margin-top: 0;
        }
      }
    }
  }
}

.carousel-item {
  background: #f9f9f9;
  padding: 10px;
  img {
    width: calc(24.9% - 20px);
    margin: 10px;
    border-radius: 4px;
  }
}

.footer-buttons {
  text-align: center;
  button {
    min-width: 200px;
  }
}

@media (max-width: 767px) {
  .profile-header {
    display: block;
    .image {
      margin: auto;
    }

    .information {
      margin: 20px 0 0;
      text-align: center;
    }

    .cta {
      text-align: center;
      margin: 20px 0;
      padding: 10px;
      border-top: 2px dashed rgba(#2b3060, 0.05);
      border-bottom: 2px dashed rgba(#2b3060, 0.05);
      .session-description {
        max-width: 9999px;
        text-align: center;
      }
    }
  }

  .general-information {
    margin-top: 30px;

    h4 {
      margin-top: 0;
    }

    table {
      tr {
        width: 100%;
      }
    }
  }

  .price {
    text-align: center;

    span {
      display: inline-block;
    }
  }

  .item {
    max-width: 100%;
  }
}
</style>

